import { ISerialRangePagination } from '@models/serial-range-pagination';

export const DefaultSerialPagination: ISerialRangePagination = {
  currentPage: 1,
  offset: 0,
  pageSerialCodes: [],
  totalCount: 0,
};
